<template>
  <div id="rooms">
    <div id="tab">
      <div
        class="tab"
        :class="{ active: listType == 'roomConnected' }"
        @click="changeRoomListType('roomConnected')"
      >
        Connected
      </div>
      <div
        class="tab"
        :class="{ active: listType == 'roomReceived' }"
        @click="changeRoomListType('roomReceived')"
      >
        Received <span :class="{ new: isNewReceived }"></span>
      </div>
      <div
        class="tab"
        :class="{ active: listType == 'roomSent' }"
        @click="changeRoomListType('roomSent')"
      >
        Sent
      </div>
    </div>

    <transition name="fade">
      <comp-message
        v-if="showMessage"
        :msgText="messageText"
        :msgSuccess="!messageIsErr"
        :msgError="messageIsErr"
        @closeMsg="showMessage = false"
      />
    </transition>

    <template v-if="roomList.length > 0">
      <comp-profile
        v-for="room in roomList"
        :key="room.roomSeqId"
        :class="{ via: getItemVia(room) }"
        :photoImage="room.image"
        :profileName="getItemName(room)"
        :profileSub="getItemSub(room)"
        :viaRoom="getItemVia(room)"
        :hasButton="true"
        :btnRooms="listType === 'roomConnected'"
        :btnInviteReceived="listType === 'roomReceived'"
        :btnInviteSent="listType === 'roomSent'"
        :userAdmin="room.role.toUpperCase() == 'ADMIN'"
        @click.native.stop="onRoomListItemClick(room)"
        @admin-click="onRoomDeleteClick(room)"
        @user-click="onRoomExitClick(room)"
        @acceptReceived="performAcceptInvite(room)"
        @deleteReceived="performRejectInvite(room)"
        @resend="performResendEmailInvite(room)"
        @dismiss="performCancelInvite(room)"
      />
    </template>
    <template v-else>
      <ul v-if="listType === 'roomConnected'">
        No rooms.
      </ul>
      <ul v-else-if="listType === 'roomReceived'">
        No new room requests.
      </ul>
      <ul v-else-if="listType === 'roomSent'">
        No sent requests.
      </ul>
    </template>

    <div class="modal full-on-mobile" id="edit-room" v-if="modalCreateRoom">
      <div class="modal-contents">
        <div class="modal-header">Create Room</div>
        <div class="modal-body">
          <div class="form-group">
            <div class="profile-photo">
              <div class="label">Room Photo</div>
              <div class="photo-wrapper">
                <div class="photo-container"></div>
                <div class="button-container">
                  <!-- <div class="btn-upload">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                      ></path>
                      <circle cx="12" cy="13" r="4"></circle>
                    </svg>
                  </div> -->
                  <input
                    type="file"
                    class="btn-upload"
                    @change="onFileSelected($event.target.files)"
                    @click="onFileUploadClick"
                    ref="docFile"
                    accept=".jpg, .jpeg, .png"
                    id="fileEvent"
                    hidden
                  />
                  <div class="btn-upload" @click="onFileUploadClickTrigger">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-container" :class="{ 'has-error': roomNameError }">
              <label class="label" for="roomname">*Room Name</label>
              <input
                type="text"
                name=""
                id="roomname"
                v-model.trim="roomName"
              />
            </div>
            <div class="form-container" :class="{ 'has-error': compNameError }">
              <label class="label" for="companyname">*Company Name</label>
              <input
                type="text"
                name=""
                id="companyname"
                v-model.trim="roomCompanyName"
              />
            </div>
            <div class="form-container" :class="{ 'has-error': descError }">
              <label class="label" for="roomname">*Description</label>
              <textarea
                name=""
                id=""
                cols="30"
                rows="5"
                v-model.trim="roomDesc"
              ></textarea>
            </div>
          </div>
          <label class="label" style="color: red">* is required field.</label>
        </div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button-container">
              <div class="button" @click="onCloseCreateRoomModal">Cancel</div>
            </div>
            <div class="button-container">
              <div class="button" @click="performCreateRoom">
                <comp-loading v-if="isLoading"></comp-loading>
                <div v-else>Create</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="btn-add"
      v-if="!modalCreateRoom && isMobile"
      @click="modalCreateRoom = true"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import RoomService from '@/services/room-service'
import CompMessage from '@/components/CompMessage'
import CompProfile from '@/components/CompProfile'
import CompLoading from '@/components/CompLoading'

export default {
  name: 'Rooms',
  mixins: [common],
  components: {
    CompProfile,
    CompMessage,
    CompLoading
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader('Rooms')
    this.$parent.setBottomTab(true)

    this.$parent.addSomething = 'Create Room'

    this.changeRoomListType(this.listType)

    this.$EventBus.$on('refresh', params => {
      if (params.listType) this.changeRoomListType(params.listType)
    })

    this.$EventBus.$on('addSomething', () => {
      this.modalCreateRoom = true
    })
  },
  data() {
    return {
      showMessage: false,
      messageText: '',
      messageIsErr: false,

      isLoading: false,

      modalCreateRoom: false,

      listType: this.$route.params.listType || 'roomConnected',
      roomList: [],
      isNewReceived: false,

      roomPhoto: null,
      roomName: '',
      roomCompanyName: '',
      roomDesc: '',

      roomNameError: false,
      compNameError: false,
      descError: false
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    }
  },
  methods: {
    performGetRoomList() {
      this.isLoading = true
      this.roomList = []

      var type
      switch (this.listType) {
        case 'roomReceived':
          type = 'invited'
          break
        case 'roomSent':
          type = 'sent'
          break
        default:
          type = 'joined'
      }
      RoomService.getRoomList(type).then(
        ({ resultCode, resultData, resultMsg }) => {
          this.isLoading = false

          if (resultCode === 0 && !this.isEmpty(resultData)) {
            this.isNewReceived = resultData.received
            this.roomList = resultData.roomList
          } else {
            this.showInfoMessage(resultMsg, true)
          }
        }
      )
    },
    performCreateRoom() {
      this.roomNameError = false
      this.compNameError = false
      this.descError = false

      const roomName = this.roomName
      const companyName = this.roomCompanyName
      const desc = this.roomDesc

      if (this.isEmpty(roomName)) {
        this.roomNameError = true
      }
      if (this.isEmpty(companyName)) {
        this.compNameError = true
      }
      if (this.isEmpty(desc)) {
        this.descError = true
      }

      if (
        !this.isEmpty(roomName) &&
        !this.isEmpty(companyName) &&
        !this.isEmpty(desc)
      ) {
        this.isLoading = true

        const roomData = {
          roomName,
          companyName,
          desc,
          roomPhoto: this.roomPhoto
        }
        RoomService.createRoom(roomData).then(({ resultCode, resultMsg }) => {
          this.isLoading = false

          this.showInfoMessage(resultMsg, resultCode !== 0)

          if (resultCode === 0) {
            this.onCloseCreateRoomModal()
            this.performGetRoomList()
          }
        })
      }
    },
    performAcceptInvite(room) {
      this.isLoading = true

      const roomSeqId = room.roomSeqId

      RoomService.roomJoin(roomSeqId).then(({ resultCode, resultMsg }) => {
        this.showInfoMessage(resultMsg, resultCode !== 0)

        if (resultCode === 0) {
          this.showInfoMessage(resultMsg)
          this.performGetRoomList()
        }
      })
    },
    performRejectInvite(room) {
      this.isLoading = true

      const roomSeqId = room.roomSeqId

      RoomService.rejectInvite(roomSeqId).then(({ resultCode, resultMsg }) => {
        this.showInfoMessage(resultMsg, resultCode !== 0)

        if (resultCode === 0) {
          this.showInfoMessage(resultMsg)
          this.performGetRoomList()
        }
      })
    },
    performResendEmailInvite(room) {
      this.isLoading = true

      const inviteUserEmail = room.userId

      if (!this.isEmpty(inviteUserEmail)) {
        const params = {
          roomSeqId: room.roomSeqId,
          userIdList: [inviteUserEmail]
        }
        RoomService.sendEmailInvite(params).then(
          ({ resultCode, resultMsg }) => {
            this.showInfoMessage(resultMsg, resultCode !== 0)

            if (resultCode === 0) {
              this.showInfoMessage(resultMsg)
              this.performGetRoomList()
            }
          }
        )
      }
    },
    performCancelInvite(room) {
      this.isLoading = true

      const memberSeqId = room.memberSeqId
      const partnerSeqId = room.partnerSeqId

      RoomService.cancelEmailInvite(memberSeqId, partnerSeqId).then(
        ({ resultCode, resultMsg }) => {
          this.showInfoMessage(resultMsg, resultCode !== 0)

          if (resultCode === 0) {
            this.showInfoMessage(resultMsg)
            this.performGetRoomList()
          }
        }
      )
    },
    getItemName(item) {
      switch (this.listType) {
        case 'roomConnected':
          return item.roomName
        default:
          return item.inviteUserName || 'Unknown'
      }
    },
    getItemSub(item) {
      switch (this.listType) {
        case 'roomConnected':
          return item.company
        default:
          return item.userId || 'Unknown'
      }
    },
    getItemVia(item) {
      switch (this.listType) {
        case 'roomConnected':
          return false
        default:
          return item.roomName
      }
    },
    changeRoomListType(listType) {
      this.roomList = []

      this.listType = listType
      this.$store.state.selectedSubMenu = listType

      this.performGetRoomList()
    },
    showInfoMessage(message, isError) {
      this.isLoading = false

      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    },
    onRoomListItemClick(roomItem) {
      if (this.listType === 'roomConnected') {
        this.goPage(`roomInfo/${roomItem.roomSeqId}`)
      }
    },
    onRoomDeleteClick(roomItem) {
      this.$parent.showDialog(
        'Delete room',
        'Would you like to delete the room?',
        () => {
          this.isLoading = true

          return RoomService.deleteRoom(roomItem.roomSeqId).then(
            ({ resultCode, resultMsg }) => {
              this.showInfoMessage(resultMsg)

              if (resultCode === 0) {
                // this.showInfoMessage(`The ${roomItem.roomName} has been deleted.`)
                this.performGetRoomList()
              }
            }
          )
        }
      )
    },
    onRoomExitClick(roomItem) {
      this.$parent.showDialog(
        'Exit Room',
        'Would you like to leave the room?',
        () => {
          this.isLoading = true

          return RoomService.exitRoom(roomItem.roomSeqId).then(
            ({ resultCode, resultMsg }) => {
              this.showInfoMessage(resultMsg)

              if (resultCode === 0) {
                this.performGetRoomList()
              }
            }
          )
        }
      )
    },
    onFileUploadClickTrigger() {
      var element = document.getElementById('fileEvent')
      element.click()
    },
    onFileUploadClick() {
      this.$refs.docFile.click()
    },
    onFileSelected(files) {
      if (files[0]) {
        this.resizeImage({
          file: files[0],
          maxSize: 500
        }).then(resizedImage => {
          const imgSize = resizedImage.size
          const maxSize = 5 * 1024 * 1024

          if (imgSize > maxSize) {
            this.$parent.showDialog(
              'Error',
              'Photos larger than 5MB cannot be uploaded.',
              () => {}
            )
          } else {
            const photoView = this.$el.querySelector('.photo-container')
            const reader = new FileReader()

            reader.onloadend = () => {
              photoView.style.backgroundImage = `url(${reader.result})`
            }
            reader.readAsDataURL(resizedImage)
            this.roomPhoto = this.convertBlobToFile(resizedImage, 'room.jpg')
          }
        })
      }
    },
    onCloseCreateRoomModal() {
      this.roomPhoto = null
      this.roomName = ''
      this.roomCompanyName = ''
      this.roomDesc = ''

      this.roomNameError = false
      this.compNameError = false
      this.descError = false

      this.modalCreateRoom = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/rooms.scss" scoped></style>
